import React, { useState, useEffect } from "react";
import { db, collection, doc, getDoc, getDocs, updateDoc } from "../firebase";

const UserList = ({ onFriendsUpdate }) => {
  const [allUsers, setAllUsers] = useState([]);
  const accountNumber = localStorage.getItem("accountNumber");

  // Fetch your current friend list (to avoid re-friending).
  const [currentFriends, setCurrentFriends] = useState([]);
  useEffect(() => {
    const fetchCurrentFriends = async () => {
      const userRef = doc(db, "users", accountNumber);
      const userSnap = await getDoc(userRef);
      if (userSnap.exists()) {
        setCurrentFriends(userSnap.data().friends || []);
      }
    };
    fetchCurrentFriends();
  }, [accountNumber]);

  // Fetch all users from Firestore (excluding yourself).
  useEffect(() => {
    const fetchAllUsers = async () => {
      const usersSnapshot = await getDocs(collection(db, "users"));
      const usersData = usersSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      const otherUsers = usersData.filter((user) => user.id !== accountNumber);
      setAllUsers(otherUsers);
    };
    fetchAllUsers();
  }, [accountNumber]);

  // Add a friend to your friend list.
  const addFriend = async (friendID) => {
    if (currentFriends.includes(friendID)) return;
    const userRef = doc(db, "users", accountNumber);
    const updatedFriends = [...currentFriends, friendID];
    try {
      await updateDoc(userRef, { friends: updatedFriends });
      setCurrentFriends(updatedFriends);
      if (onFriendsUpdate) onFriendsUpdate(updatedFriends);
    } catch (error) {
      console.error("Error adding friend:", error);
    }
  };

  return (
    <div>
      <h3>Find Users</h3>
      <ul>
        {allUsers.map((user) => (
          <li key={user.id}>
            {user.name} (ID: {user.id}){" "}
            {!currentFriends.includes(user.id) && (
              <button onClick={() => addFriend(user.id)}>Friend</button>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default UserList;
